import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-overall-sentiment-smile-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfOverallSentimentSmileIconProps extends SvgIconProps {}

/**
 * Component to render overall sentiment icon for positve score in RTIG
 * @param props - CcfOverallSentimentSmileIconProps
 * @example <CcfOverallSentimentSmileIcon />
 * @returns
 */
export function CcfOverallSentimentSmileIcon(
  props: CcfOverallSentimentSmileIconProps
) {
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.6 7.36C6.48 7.36 7.2 6.64 7.2 5.76C7.2 4.88 6.48 4.16 5.6 4.16C4.72 4.16 4 4.88 4 5.76C4 6.64 4.72 7.36 5.6 7.36ZM10.4 7.44C11.28 7.44 12 6.72 12 5.84C12 4.96 11.28 4.24 10.4 4.24C9.52 4.24 8.8 4.96 8.8 5.84C8.8 6.72 9.52 7.44 10.4 7.44ZM11.44 10H4.64C4.48 10 4.32 10.08 4.16 10.16C3.84 10.4 3.84 10.88 4.08 11.2C5.04 12.4 6.48 13.12 8 13.04C9.44 13.04 10.8 12.4 11.76 11.28C12 11.12 12.08 10.88 12.08 10.56C12 10.24 11.76 10 11.44 10ZM8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.4C4.48 14.4 1.6 11.52 1.6 8C1.6 4.48 4.48 1.6 8 1.6C11.52 1.6 14.4 4.48 14.4 8C14.4 11.52 11.52 14.4 8 14.4Z"
        fill="#1F7526"
      />
    </SvgIcon>
  );
}

export default CcfOverallSentimentSmileIcon;
